module.exports = __webpack_public_path__ + "img/Ricardo.ac2591f0.png";